import { useMe } from "./useMe";
import { resolveMembership } from "./useFamilyMembership";
import type { BetaFeature } from "@family/shared";

/**
 * Returns true when the current user has been enrolled in a beta feature
 * for their primary family. Admins who can grant features (members:manage)
 * always get every feature — the API reports them as enrolled in /me.
 *
 * Returns `null` while /me is still loading — callers should treat that as
 * "not yet" and avoid flicker.
 */
export function useFeature(feature: BetaFeature): boolean | null {
  const meQuery = useMe();
  if (meQuery.isLoading || !meQuery.data) return null;

  const membership = resolveMembership(meQuery.data);
  if (!membership) return false;

  return membership.features.includes(feature);
}
